import React, { FC } from "react";

import GradientDialog from "@components/Dialog";
import { ESignUp } from "@layouts/SecondRootLayout";

import VerifyEmail from "./components/VerifyEmail";
import Welcome from "./components/Welcome";

interface ISignUpDialog {
  open: boolean;
  handleClose: () => void;
  step: ESignUp;
  handleNextStep: () => void;
  /** Dev preview (DevModalLauncher): VerifyEmail skips its real code send. */
  devPreview?: boolean;
}

const renderDialogContent = (step: number, handleClose: () => void, handleNextStep: () => void, devPreview?: boolean) => {
  switch (step) {
    // case ESignUp.Links:
    //   return <Links />;
    // case ESignUp.ClassifyContent:
    //   return <ClassifyContent />;
    // case ESignUp.UseCases:
    //   return <UseCases />;
    // case ESignUp.AcceptTerms:
    //   return <AcceptTerms />;
    case ESignUp.VerifyEmail:
      return <VerifyEmail handleNextStep={handleNextStep} devPreview={devPreview} />;
    case ESignUp.Welcome:
      return <Welcome handleClose={handleClose} />;
    default:
      return null;
  }
};

const SignUpDialog: FC<ISignUpDialog> = ({ step, handleClose, open, handleNextStep, devPreview }) => {
  const isNotScrollable = ESignUp.VerifyEmail === step || ESignUp.Welcome === step;

  return (
    <GradientDialog
      open={open}
      handleClose={handleClose}
      isClosable={false}
      isNotScrollable={isNotScrollable}
      sx={{
        "&&": {
          ".MuiDialog-paper": {
            maxHeight: `calc(100dvh - 40px)`,
          },
          ".MuiDialog-paper > div > div": {
            maxHeight: `calc(100dvh - 40px)`,
          },
        },
      }}
    >
      {renderDialogContent(step, handleClose, handleNextStep, devPreview)}
    </GradientDialog>
  );
};

export default SignUpDialog;
